import styled from 'styled-components';
import {BGImageCenter} from '../../../../../../globalVariables/GlobalVariables';
import {dFlexCenter, dFlexColumn, flexWrap} from '../../../../../../globalVariables/GlobalFlex';
import {responsive, getSpacing, getFontSize, getFontWeight, tokens} from '@tickchak/react-share/app';

export const container = styled.div`
    position: relative;
    width: 100%;
    ${dFlexColumn}
    ${responsive(getSpacing('spaceXl'), 'gap')};
`;

export const sectionTitle = styled.h2`
    ${responsive(getFontSize('h3'), 'font-size')};
`;

export const typesGrid = styled.div`
    ${dFlexCenter}
    ${flexWrap}
    ${responsive(getSpacing('spaceXl'), 'gap')};
`;

export const badge = styled.div<{$disabled?: boolean}>`
    height: ${responsive(tokens.button.buttonHeight.category, 'height')};
    width: max-content;
    ${responsive(tokens.button.buttonBorderRadius, 'border-radius')};
    background: ${tokens.color.brand.main};
    ${dFlexCenter}
    ${responsive(getFontWeight('medium'), 'font-weight')};
    ${responsive(getSpacing('spaceSm'), 'padding-inline')};
    ${p => p.$disabled && `
        background: ${tokens.color.brand.disabled};
    `}
`;

export const inputWrapper = styled.div`
    width: 100%;
    margin-bottom: ${responsive(getSpacing('spaceLg'), 'margin-bottom')};
`;

export const inputIcon = styled.div<{$icon: string}>`
    width: 17px;
    height: 17px;
    ${p => BGImageCenter(p.$icon, '17px')}
`;

